'use client';

import { Drawer, DrawerContent } from '@streetferret/ui-web/drawer';
import { cn } from '@streetferret/utils';
import * as React from 'react';

export function MobileTrackDrawer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const snapPoints = React.useMemo<(string | number)[]>(
    () => ['150px', '325px', 0.95],
    [],
  );
  const expandedSnapPoint = snapPoints[snapPoints.length - 1]!;
  const [snapPoint, setSnapPoint] = React.useState<string | number | null>(
    snapPoints[1]!,
  );

  return (
    <Drawer
      open={true}
      modal={false}
      dismissible={false}
      shouldScaleBackground={false}
      scrollLockTimeout={900}
      activeSnapPoint={snapPoint}
      setActiveSnapPoint={setSnapPoint}
      snapPoints={snapPoints}>
      <DrawerContent
        className={cn(
          'lg:hidden',
          'mx-auto max-w-2xl border-x border-b-0',
          'rounded-t-[28px] bg-background/80 shadow-2xl backdrop-blur-xl',
          className,
        )}>
        <div
          className={cn(
            'h-full min-h-[10vh] overscroll-none',
            'pb-[calc(env(safe-area-inset-bottom)+96px)]',
            {
              'overflow-y-auto overscroll-contain':
                snapPoint === expandedSnapPoint,
            },
          )}>
          {children}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
